import React, { Component } from "react";
import { Link } from "react-router-dom";
import calcularPx from "../general/calcularPx.js";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { CustomLeftArrow, CustomRightArrow } from "../general/customArrow";

const BannersDesktop = ({ banners }) => {
  const responsive = {
    todo: { breakpoint: { max: 10000, min: 0 }, items: 1 },
  };
  return (
    <React.Fragment>
      <div
        style={{
          position: "relative",
          maxWidth: "100%",
          overflow: "hidden",
          zIndex: 0,
        }}
      >
        <Carousel
          responsive={responsive}
          showDots={true}
          draggable={false}
          infinite={true}
          autoPlay={true}
          partialVisible={false}
          customLeftArrow={<CustomLeftArrow />}
          customRightArrow={<CustomRightArrow />}
        >
          {banners.primero
            .filter((e) => e.plataforma == 0 || e.plataforma == 2)
            .map((e, i) => {
              return (
                <Link to={e.link}>
                  <div
                    style={{
                      maxHeight: "822px",
                    }}
                  >
                    <img
                      alt={"banner1-" + i}
                      src={e.url}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                </Link>
              );
            })}
        </Carousel>
      </div>

      <div style={{ height: calcularPx(64), width: "100%" }} />

      <Link to={"/productos/termotanquesGas"}>
        <div
          style={{
            position: "relative",
            marginLeft: "3.44%",
            marginRight: "3.44%",
            borderTopLeftRadius: calcularPx(35),
            borderTopRightRadius: calcularPx(35),
            background: "#FFB000",
            height: calcularPx(382),
          }}
        >
          <img
            src={require("../../res/banners/home-termotanques.png")}
            style={{
              position: "absolute",
              left: "0%",
              top: calcularPx(-59),
              objectFit: "cover",
              width: calcularPx(639),
              maxWidth: "60%",
              height: "auto",
            }}
          />
          <div style={{ height: calcularPx(36), width: "100%" }} />
          <div
            style={{
              color: "#FFFFFF",
              textAlign: "right",
              fontWeight: 700,
              lineHeight: calcularPx(35),
              fontSize: calcularPx(35),
              paddingRight: calcularPx(44),
              fontFamily: "Nunito",
            }}
          >
            Termotanques
          </div>
          <div
            style={{
              color: "#FFFFFF",
              textAlign: "right",
              fontWeight: 400,
              lineHeight: calcularPx(35),
              fontSize: calcularPx(35),
              paddingRight: calcularPx(44),
              fontFamily: "Nunito",
            }}
          >
            a gas
          </div>
          <div style={{ height: calcularPx(53), width: "100%" }} />
          <div
            style={{
              height: calcularPx(169),
              width: "75%",
              marginLeft: "auto",
              marginRight: calcularPx(44),
              background: "#FFFFFF",
              borderRadius: calcularPx(20),
            }}
          >
            <div
              style={{
                paddingTop: "2%",
                marginLeft: "auto",
                maxWidth: calcularPx(555),
                paddingRight: "3%",
                textAlign: "right",
                color: "#5A5A5A",
                fontSize: calcularPx(17),
                fontFamily: "Nunito",
              }}
            >
              Equipos tanto para gas natural como para gas envasado, de conexión
              superior, para colocar apoyado o de colgar.
              <br />
              Diseño compacto que ocupa menos volúmen.
            </div>
            <div
              style={{
                background: "#FFB000",
                color: "#FFFFFF",
                fontSize: calcularPx(17),
                fontFamily: "Nunito",
                height: calcularPx(22),
                lineHeight: calcularPx(22),
                width: calcularPx(100),
                marginTop: calcularPx(17),
                marginLeft: "auto",
                marginRight: "3%",
                borderRadius: calcularPx(20),
                paddingLeft: calcularPx(16),
                paddingRight: calcularPx(16),
                textAlign: "center",
              }}
            >
              ver más
            </div>
          </div>
        </div>
        <div style={{ height: calcularPx(198), width: "100%" }} />
      </Link>

      <Link to={"/productos/convectores"}>
        <div
          style={{
            position: "relative",
            marginLeft: "3.44%",
            marginRight: "3.44%",
            background: "#FFFFFF",
            height: calcularPx(382),
          }}
        >
          <img
            src={require("../../res/banners/home-convectores.png")}
            style={{
              position: "absolute",
              right: "0%",
              top: calcularPx(-244),
              objectFit: "cover",
              maxWidth: calcularPx(812),
              height: "auto",
            }}
          />
          <div style={{ height: calcularPx(36), width: "100%" }} />
          <div
            style={{
              color: "#727272",
              textAlign: "left",
              fontWeight: 700,
              lineHeight: calcularPx(35),
              fontSize: calcularPx(35),
              fontFamily: "Nunito",
            }}
          >
            Convectores
          </div>
          <div
            style={{
              color: "#727272",
              textAlign: "left",
              fontWeight: 400,
              lineHeight: calcularPx(35),
              fontSize: calcularPx(35),
              fontFamily: "Nunito",
            }}
          >
            a gas
          </div>
          <div style={{ height: calcularPx(53), width: "100%" }} />
          <div
            style={{
              height: calcularPx(169),
              width: "75%",
              marginRight: "auto",
              marginLeft: 0,
              background: "#FFB000",
              borderRadius: calcularPx(20),
            }}
          >
            <div
              style={{
                paddingTop: "2%",
                marginRight: "auto",
                maxWidth: calcularPx(555),
                paddingLeft: "3%",
                textAlign: "left",
                color: "#FFFFFF",
                fontSize: calcularPx(17),
                fontFamily: "Nunito",
              }}
            >
              Conocé la linea completa de calefactores multigas Uniqo.
              <br />
              Diseñados para brindar el calor más eficiente a tu hogar.
            </div>
            <div
              style={{
                background: "#FFFFFF",
                color: "#FFB000",
                fontSize: calcularPx(17),
                fontFamily: "Nunito",
                height: calcularPx(22),
                lineHeight: calcularPx(22),
                width: calcularPx(100),
                marginTop: calcularPx(34),
                marginRight: "auto",
                marginLeft: "3%",
                borderRadius: calcularPx(20),
                paddingLeft: calcularPx(16),
                paddingRight: calcularPx(16),
                textAlign: "center",
              }}
            >
              ver más
            </div>
          </div>
        </div>
      </Link>

      <div style={{ height: calcularPx(86), width: "100%" }} />

      <Link to={"/dondeComprar"}>
        <div
          style={{
            position: "relative",
            width: "100%",
            height: calcularPx(540),
            background: "#FFB000",
            paddingLeft: "7%",
          }}
        >
          <img
            src={require("../../res/banners/home-dondeComprar.png")}
            style={{
              position: "absolute",
              right: "7%",
              top: calcularPx(-29),
              objectFit: "cover",
              maxWidth: calcularPx(762),
              height: "auto",
            }}
          />
          <div style={{ height: calcularPx(90), width: "100%" }} />
          <div
            style={{
              color: "#FFFFFF",
              fontSize: calcularPx(50),
              maxWidth: calcularPx(400),
              fontFamily: "Nunito",
            }}
          >
            Dónde comprar?
          </div>
          <div style={{ height: calcularPx(25), width: "100%" }} />
          <div
            style={{
              color: "#404040",
              fontSize: calcularPx(25),
              maxWidth: calcularPx(400),
              fontFamily: "Nunito",
            }}
          >
            Buscá por ubicación geográfica los comercios en donde encontrás los
            productos Uniqo
          </div>
          <div style={{ height: calcularPx(128), width: "100%" }} />
          <div
            style={{
              background: "#404040",
              color: "#FFFFFF",
              fontSize: calcularPx(25),
              fontFamily: "Nunito",
              height: calcularPx(47),
              lineHeight: calcularPx(47),
              width: calcularPx(165),
              borderRadius: calcularPx(20),
              textAlign: "center",
            }}
          >
            Buscar
          </div>
        </div>
      </Link>
      <div style={{ height: calcularPx(82), width: "100%" }} />
    </React.Fragment>
  );
};

export default BannersDesktop;
